/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import "../../EmployeeScreens/EmployeeProfile/EMPProfile.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Apiurl, GetToken, RemoveUserSession } from "../../../Utils/utils";
import axios from "axios";
import moment from "moment";
import Loader from "../../../Components/loader/loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useProfile } from "../../../Context/ProfileContext";
import Cropper from "react-easy-crop";

const EMPProfile = () => {
  const navigate = useNavigate();
  const { profileData, fetchProfile } = useProfile();
  const [errorFirstName, setErrorFirstName] = useState(null);
  const [dummy, setDummy] = useState(false);
  const [errorEmergencyContactNumber, setErrorEmergencyContactNumber] =
    useState(null);
  const [errorMobile, setErrorMobile] = useState(null);
  const [errorAddress, setErrorAddress] = useState(null);
  const [newImageUrl, setNewImageUrl] = useState("");
  const [photoExtension, setPhotoExtension] = useState("");
  const fileInputRef = useRef(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [ProfileData, setProfileData] = useState("");
  const [loading, setLoading] = useState(false);
  const adhaarFileInputRef = useRef(null);
  const [errorMaritalStatus, setErrorMaritalStatus] = useState(null);
  const [profileImageFile, setProfileImageFile] = useState(null);
  const [adhaarImageFiles, setAdhaarImageFiles] = useState([]); // Declare adhaarImageFiles variable
  const LoginToken = GetToken();
  const firstNameRef = useRef(null);
  const mobileRef = useRef(null);
  const emergencyRef = useRef(null);
  const addressRef = useRef(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [imageType, setImageType] = useState("");
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [originalProfileData, setOriginalProfileData] = useState(null);
  const [profileAlldata, setProfileAllData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    Mobile: "",
    Gender: "",
    MaritalStatus: "",
    DateOfBirth: "",
    Department: "",
    Designation: "",
    Address: "",
    UrlLink: "",
    AdhaarLink: "",
    Emergencycontactno: "",
    TeamLeads: "",
  });

  const validate = () => {
    setErrorFirstName(null);
    setErrorMobile(null);
    setErrorEmergencyContactNumber(null);
    setErrorAddress(null);

    if (!profileAlldata?.FirstName?.trim()) {
      setErrorFirstName("First name is required.");
      firstNameRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    if (!profileAlldata?.Mobile || profileAlldata.Mobile.length !== 10) {
      setErrorMobile("Mobile number must be exactly 10 digits.");
      mobileRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    if (!profileAlldata?.Emergencycontactno || profileAlldata.Emergencycontactno.length !== 10) {
      setErrorEmergencyContactNumber(
        "Emergency contact number must be exactly 10 digits."
      );
      emergencyRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    if (!profileAlldata?.Address?.trim()) {
      setErrorAddress("Address is required.");
      addressRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }

    return true;
  };

  const Gender = [
    { value: "Male", label: "Male", id: 0 },
    { value: "Female", label: "Female", id: 1 },
    { value: "Transgender", label: "Transgender", id: 2 },
  ];

  const MaritalStatusOptions = [
    { value: "Single", label: "Single", id: 0 },
    { value: "Married", label: "Married", id: 1 },
    { value: "Divorced", label: "Divorced", id: 2 },
    { value: "Widowed", label: "Widowed", id: 3 },
  ];
  useEffect(() => {
    setProfileData((prevProfileData) => ({
      ...prevProfileData,
      Mobile: "",
      Gender: "",
      DateOfBirth: "",
      Department: "",
    }));
  }, []);
  useEffect(() => {
    if (profileData) {
      const gender = Gender?.find((e) => e?.id === profileData?.Gender);
      const maritalStatus = MaritalStatusOptions?.find(
        (e) => e?.id === profileData?.MaritalStatus
      );

  //     setProfileData(profileData);

  //     setProfileAllData((prev) => ({
  //       ...prev,
  //       FirstName: profileData?.FirstName,
  //       LastName: profileData?.LastName,
  //       Email: profileData?.Email,
  //       Mobile: profileData?.Mobile?.slice(0, 10),
  //       DateOfBirth: profileData?.DateOfBirth,
  //       Gender: gender,
  //       Department: profileData?.Departments?.Name,
  //       Designation: profileData?.Designations?.DesignationName,
  //       Address: profileData?.Address,
  //       UrlLink: profileData?.UrlLink,
  //       Emergencycontactno: profileData?.Emergencycontactno,
  //       TeamLeads: profileData?.TeamLeads?.UserName,
  //       MaritalStatus: maritalStatus,
  //       AdhaarLink: profileData?.AadharCard,
  //     }));
  //   }
  // }, [profileData]);

    const mappedData = {
      FirstName: profileData?.FirstName || "",
      LastName: profileData?.LastName || "",
      Email: profileData?.Email || "",
      Mobile: profileData?.Mobile?.slice(0, 10) || "",
      DateOfBirth: profileData?.DateOfBirth || "",
      Gender: gender || "",
      Department: profileData?.Departments?.Name || "",
      Designation: profileData?.Designations?.DesignationName || "",
      Address: profileData?.Address || "",
      UrlLink: profileData?.UrlLink || "",
      Emergencycontactno: profileData?.Emergencycontactno || "",
      TeamLeads: profileData?.TeamLeads?.UserName || "",
      MaritalStatus: maritalStatus || "",
      AdhaarLink: profileData?.AadharCard || "",
    };

    setProfileAllData(mappedData);

    // 🔥 VERY IMPORTANT (backup copy)
    setOriginalProfileData(mappedData);
  }
}, [profileData]);

  const handleImageChange = (e) => {
  const file = e.target.files[0];

  if (!file) return;
  if (!file.type.startsWith("image/")) {
    toast.error("Please upload a valid image file");
    return;
  }

  setImageType(file.type);
  const extension = file.type.split("/")[1];
setPhotoExtension(extension);

  const reader = new FileReader();
  reader.onloadend = () => {
    setNewImageUrl(reader.result);
    setShowCropModal(true);
  };

  reader.readAsDataURL(file);
  setProfileImageFile(file);
};

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const getCroppedImg = async () => {
  const image = new Image();
  image.src = newImageUrl;

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;

  ctx.drawImage(
    image,
    croppedAreaPixels.x,
    croppedAreaPixels.y,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
    0,
    0,
    croppedAreaPixels.width,
    croppedAreaPixels.height
  );

  return canvas.toDataURL(imageType);
};

  const applyCrop = async () => {
  const croppedImage = await getCroppedImg();

  setProfileAllData((prev) => ({
    ...prev,
    UrlLink: croppedImage,
  }));

  setNewImageUrl(croppedImage);
  setShowCropModal(false);
};

  const handleAdhaarChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;
    if (adhaarImageFiles.length >= 2) {
      toast.error("Maximum 2 files allowed");
      return;
    }
    setAdhaarImageFiles((prev) => [...prev, file]);
    e.target.value = "";
  };

  const handleUpdateProfile = (clicked) => {
    if (!validate()) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("Id", ProfileData?.Id);
    formData.append("FirstName", profileAlldata?.FirstName);
    formData.append("LastName", profileAlldata?.LastName);
    formData.append("Gender", profileAlldata?.Gender?.id);
    formData.append("Mobile", profileAlldata?.Mobile);
    formData.append("Address", profileAlldata?.Address);
    formData.append("DateOfBirth", profileAlldata?.DateOfBirth);
    if (photoExtension) {
  formData.append("PhotoExtenssion", photoExtension);
}
    formData.append("Emergencycontactno", profileAlldata?.Emergencycontactno);
    if (profileAlldata?.MaritalStatus?.id !== undefined) {
      formData.append("MaritalStatus", profileAlldata?.MaritalStatus?.id);
    }
    if (profileAlldata?.UrlLink) {
  const base64Photo = profileAlldata?.UrlLink?.split("base64,")?.[1] || "";
  if (base64Photo) {
    formData.append("Photo", base64Photo);
  }
}
    if (profileAlldata?.AdhaarLink) {
      const base64Adhaar = profileAlldata?.AdhaarLink?.split("base64,")?.[1] || "";
      if (base64Adhaar) {
        formData.append("AadharCard", base64Adhaar);
      }
    }
    if (adhaarImageFiles.length > 0) {
  adhaarImageFiles.forEach((file) => {
    formData.append("AadharFiles", file);
  });
}

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Profile/UpdateProfile`,
      data: formData,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (clicked === "update") {
          setDummy(true);
        }
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setProfileImageFile(null);
          setAdhaarImageFiles([]);
          setTimeout(() => fetchProfile(), 500);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const handleRemoveAdhaarFile = (index) => {
    setAdhaarImageFiles((prev) =>
      prev.filter((_, i) => i !== index)
    );
  };

  const handleRemoveProfilePhoto = () => {
    setNewImageUrl("");
    setProfileImageFile(null);
    setProfileAllData((prev) => ({
      ...prev,
      UrlLink: "",
    }));
  };
const handleCancel = () => {
  if (!originalProfileData) return; // safety

  setProfileAllData(originalProfileData);
  setNewImageUrl("");
  setAdhaarImageFiles([]);
  setErrorAddress(null);
};
  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} dummy={dummy} setDummy={setDummy} />
        <section
          className={
            showSidebar
              ? "EMP-profile-main-section"
              : "EMP-profile-main-section-new"
          }
        >
          <div className="EMP-profile-all-icons">
            <div>
              <p className="MAIN-HEADING">Profile </p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="EMP-home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p> Profile </p>
              <MdKeyboardArrowRight />
              <p> Profile </p>
            </div>
          </div>
          <div className="EMP-profile-main-container">
            <div className="EMP-profile-outter-container">
              <div className="EMP-profile-inner-container">
                <div className="EMP-profile-heading">
                  <p> Profile</p>
                </div>
                <div className="EMP-profile-inner-box row">
                  <div className="profile-inputs-disabled col-12">
                    <FloatingLabelInput
                      label="Email*"
                      value={profileAlldata?.Email?.trim() || ""}
                      onChange={(e) =>
                        setProfileAllData((prev) => ({
                          ...prev,
                          Email: e?.target?.value,
                        }))
                      }
                      style={{ marginBottom: 0 }}
                      disabled
                    />
                  </div>
                  <div className="profile-inputs col-6" ref={firstNameRef}>
                    <FloatingLabelInput
                      label="FirstName*"
                      value={profileAlldata.FirstName || ""}
                      onChange={(e) =>
                        setProfileAllData((prev) => ({
                          ...prev,
                          FirstName: e?.target?.value,
                        }))
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value?.trim()) {
                          setErrorFirstName("First name is required.");
                        } else {
                          setErrorFirstName(null);
                        }
                      }}
                    />
                    {errorFirstName && (
                      <span className="contact_error-dob">{errorFirstName}</span>
                    )}
                  </div>
                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="LastName"
                      value={profileAlldata?.LastName || ""}
                      onChange={(e) =>
                        setProfileAllData((prev) => ({
                          ...prev,
                          LastName: e?.target?.value,
                        }))
                      }
                    />
                  </div>


                  <div className="profile-inputs col-6" ref={mobileRef}>
                    <FloatingLabelInput
                      label="Mobile*"
                      maxLength="10"
                      value={profileAlldata.Mobile || ""}
                      onChange={(e) => {
                        const inputMobile = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setProfileAllData((prev) => ({
                          ...prev,
                          Mobile: inputMobile,
                        }));
                      }}
                      onBlur={(e) => {
                        if (e.target.value.length !== 10) {
                          setErrorMobile("Mobile number must be exactly 10 digits.");
                        } else {
                          setErrorMobile(null);
                        }
                      }}
                    />
                    {errorMobile && (
                      <span className="contact_error-dob">{errorMobile}</span>
                    )}
                  </div>
                  <div className="profile-inputs col-6" ref={emergencyRef}>
                    <FloatingLabelInput
                      label="Emergency Contact Number *"
                      maxLength="10"
                      value={profileAlldata?.Emergencycontactno || ""}
                      onChange={(e) => {
                        const inputMobile = e?.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setProfileAllData((prev) => ({
                          ...prev,
                          Emergencycontactno: inputMobile,
                        }));
                      }}
                      onBlur={(e) => {
                        if (e.target.value.length !== 10) {
                          setErrorEmergencyContactNumber(
                            "Emergency contact number must be exactly 10 digits."
                          );
                        } else {
                          setErrorEmergencyContactNumber(null);
                        }
                      }}
                    />
                    {errorEmergencyContactNumber && (
                      <span className="contact_error-dob">
                        {errorEmergencyContactNumber}
                      </span>
                    )}
                  </div>

                  <div className="profile-inputs col-6">
                    <label htmlFor="">Date Of Birth</label>
                    <input
                      type="date"
                      label="DateOfBirth*"
                      value={
                        profileAlldata?.DateOfBirth
                          ? moment(profileAlldata.DateOfBirth).format("YYYY-MM-DD")
                          : ""
                      }
                      onChange={(e) => {
                        const formattedDate = moment(e?.target?.value).format(
                          "DD MMMM YYYY"
                        );
                        setProfileAllData((prev) => ({
                          ...prev,
                          DateOfBirth: formattedDate,
                        }));
                      }}
                    />
                  </div>
                  <div className="profile-inputs col-6">
                    <label className="label-manaegement-section">Gender *</label>
                    <select
                      className="profile-select-input"
                      value={profileAlldata?.Gender?.id ?? ""}
                      onChange={(e) => {
                        const selectedGender = Gender.find(
                          (g) => g.id === parseInt(e.target.value)
                        );
                        setProfileAllData((prev) => ({
                          ...prev,
                          Gender: selectedGender,
                        }));
                      }}
                    >
                      <option value="">Select Gender</option>
                      {Gender.map((g) => (
                        <option key={g.id} value={g.id}>
                          {g.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="profile-inputs col-6">
                    <label htmlFor="" className="label-manaegement-section">
                      Marital Status
                    </label>
                    <select
                      className="profile-select-input"
                      value={profileAlldata?.MaritalStatus?.id ?? ""}
                      onChange={(e) => {
                        const selectedStatus = MaritalStatusOptions.find(
                          (status) => status.id === parseInt(e.target.value)
                        );
                        setProfileAllData((prev) => ({
                          ...prev,
                          MaritalStatus: selectedStatus,
                        }));
                      }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorMaritalStatus("Marital status is required.");
                        } else {
                          setErrorMaritalStatus(null);
                        }
                      }}
                    >
                      <option value="">Select Marital Status</option>
                      {MaritalStatusOptions.map((status) => (
                        <option key={status.id} value={status.id}>
                          {status.label}
                        </option>
                      ))}
                    </select>
                    {errorMaritalStatus && (
                      <span className="contact_error-dob">{errorMaritalStatus}</span>
                    )}
                  </div>
                  <div className="profile-inputs-for-image col-6">
                    <label htmlFor="profileImage">Profile Image</label>
                    <div className="profile-image-wrapper">

                      <input
                        type="file"
                        id="profileImage"
                        ref={fileInputRef}
                        onChange={handleImageChange}
                        className="hidden-file-input"
                      />

                      <div
                        className="image-upload-box"
                        onClick={() => fileInputRef.current.click()}
                      >
                        {newImageUrl || profileAlldata?.UrlLink ? (
                          <div className="image-preview-container">
                            <img
                              className="image-of-profile"
                              src={newImageUrl || profileAlldata?.UrlLink}
                              alt="Profile"
                            />
                            <button
                              type="button"
                              className="image-remove-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveProfilePhoto();
                              }}
                            >
                              ✕
                            </button>
                          </div>
                        ) : (
                          <span>Click to upload</span>
                        )}
                      </div>

                    </div>
                  </div>
                  <div className="profile-inputs col-12">
                    <label className="label-manaegement-section">
                      Adhaar Upload (Max 2 Files)
                    </label>

                    {/* Hidden real input */}
                    <input
                      type="file"
                      id="adhaarImage"
                      ref={adhaarFileInputRef}
                      onChange={handleAdhaarChange}
                      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                      className="hidden-file-input"
                    />

                    {/* Styled field */}
                    <div
                      className="custom-file-field"
                      onClick={() => adhaarFileInputRef.current.click()}
                    >
                      {adhaarImageFiles.length > 0
                        ? `${adhaarImageFiles.length} file(s) selected`
                        : "Click to upload Aadhaar"}
                    </div>

                    {/* Selected files list */}
                    <div className="adhaar-file-list">
                      {adhaarImageFiles.map((file, index) => (
                        <div key={index} className="adhaar-file-item">
                          <span>{file.name}</span>
                          <button
                            type="button"
                            className="remove-file-btn"
                            onClick={() => handleRemoveAdhaarFile(index)}
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                  {profileAlldata.Department ? (
                    <div className="profile-inputs-disabled col-4 ">
                      <FloatingLabelInput
                        label="Department*"
                        value={profileAlldata.Department}
                        onChange={(e) =>
                          setProfileAllData((prev) => ({
                            ...prev,
                            Department: e?.target?.value,
                          }))
                        }
                        disabled
                      />
                    </div>
                  ) : null}

                  {profileAlldata?.Designation ? (
                    <div className="profile-inputs-disabled col-4">
                      <FloatingLabelInput
                        label="Designation*"
                        value={profileAlldata?.Designation || ""}
                        onChange={(e) =>
                          setProfileAllData((prev) => ({
                            ...prev,
                            Designation: e?.target?.value,
                          }))
                        }
                        disabled
                      />
                    </div>
                  ) : null}
                  {profileAlldata?.TeamLeads ? (
                    <div className="profile-inputs-disabled col-4">
                      <FloatingLabelInput
                        label="Team Lead*"
                        value={profileAlldata?.TeamLeads || ""}
                        onChange={(e) =>
                          setProfileAllData((prev) => ({
                            ...prev,
                            TeamLeads: e?.target?.value,
                          }))
                        }
                        disabled
                      />
                    </div>
                  ) : null}

                  <div className="profile-text-area col-md12" ref={addressRef}>
                    <label htmlFor="">Address</label>
                    <textarea
                      id="address"
                      cols="30"
                      rows="8"
                      value={profileAlldata.Address || ""}
                      onChange={(e) =>
                        setProfileAllData((prev) => ({
                          ...prev,
                          Address: e?.target?.value,
                        }))
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value?.trim()) {
                          setErrorAddress("Address is required.");
                        } else {
                          setErrorAddress(null);
                        }
                      }}
                    />
                    {errorAddress && (
                      <span className="contact_error-dob">{errorAddress}</span>
                    )}
                  </div>
                  <div className="Addemployee-buttons">
                    <button
                      className="Profile-submit-button"
                      onClick={() => handleUpdateProfile("update")}
                    >
                      {profileAlldata ? "Update" : "submit"}
                    </button>
                    <button className="Profile-Cancel-button"  onClick={handleCancel}
> Cancel </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showCropModal && (
            <div className="crop-modal">
              <div className="crop-container">
                <Cropper
                  image={newImageUrl}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                />
              </div>

              <div className="crop-controls">
                <input
                  type="range"
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onChange={(e) => setZoom(e.target.value)}
                />

                <button onClick={applyCrop}>Save Crop</button>
                <button onClick={() => setShowCropModal(false)}>Cancel</button>
              </div>
            </div>
          )}
        </section>
      </div>
    </>
  );
};
export default EMPProfile;
